
import React, { useState, useEffect, Fragment } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { SimpleLoading } from '../../pures'
import { Checkbox } from '@progress/kendo-react-inputs'
import { Field } from '@progress/kendo-react-form'
import OpenPay from '../../../assets/logos/icons/openpay_color.png'
import { MaskedTextBox } from "@progress/kendo-react-inputs"
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Label } from '@progress/kendo-react-labels'
import './payment-process.css'
import { PDFDropdown } from 'pdf-lib'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};

function PaymentProcessView(props) {
  const { t } = useTranslation()
  const [cardName, setCardName] = useState(false)
  const [securityCode, setSecurityCode] = useState(false)
  const [subtotal, setSubtotal] = useState('')
  const [IVA, setIVA] = useState('')
  const longmatches = useMediaQuery('(max-width:1200px)')
  const longmatchesPay = useMediaQuery('(max-width:570px)')

  let formatter = new Intl.NumberFormat("en-MX", { style: 'currency', currency: 'MXN', currencyDisplay: 'narrowSymbol' }, {
    style: "currency",
    currency: "MXN"
  })


  const globalContainerStyles = {
    display: 'flex',
    justifyContent: 'flex-start',
    maxWidth: '100%',
    backgroundColor: 'white',
    width: 'auto',
    marginTop: '10px'
  }

  if (longmatches) {
    globalContainerStyles.marginRight = 0
  }

  if (longmatchesPay) {
    globalContainerStyles.display = 'grid'
  }

  const iconTooltipStyles = {
    color: '#929292',
    fontSize: '15px',
    // marginLeft: '5px',
    padding: '5px',
    cursor: 'pointer'
  }

  const getIVA = (amount) => {
    let iva = Number(amount) * 0.16
    let subtotal = Number(amount) - Number(iva)
    subtotal = formatter.format(subtotal)
    iva = formatter.format(iva)


    setSubtotal(subtotal)
    setIVA(iva)
  }

  useEffect(() => {
    getIVA(props.selectedPlanLevel.originalPrice)
  }, [])

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open)
  const hiddeTooltip = () => setOpen(false)

  return (
    <Container spacing={4} lg={12} md={12} sm={12} xs={12} style={{ maxWidth: '100%' }} className='container-payment'>
      <div className='container-payment'>
        <Grid lg={12} md={12} sm={12} xs={12} container direction='row' spacing={4}>
          <Grid lg={3} md={12} sm={12} xs={12} item>
            <div className='items-payment-information-a3'>
              <span>{t('planProcessView.fiscalDataA3')}</span><br></br>
              <span>{t('planProcessView.fiscalDataRfcA3')}</span><br></br>
              <span>{t('planProcessView.directionA3')}</span><br></br>
              <span>{t('planProcessView.streetA3')}</span><br></br>
              <span>{t('planProcessView.postalCodeA3')}</span>
            </div>
            <div className='items-payment-information' >
              <p className='items-payment-request-by'>{t('planProcessView.requestBy')}</p>
              <span>{props.firstName + " " + props.firstLastName + " " + props.secondLastName}</span><br></br>
              <span>{props.rfc}</span><br></br>
              <span>{props.cellphoneNumber}</span><br></br>
              {props.street && (<span>{props.street + " " + props.colony + " " + props.township + " " + props.state + " " + props.zipCode}</span>)}
            </div>
            {/* <span className='text-information'>Por si quieren agregar un texto adicional</span> */}
          </Grid>
          <Grid lg={9} md={12} sm={12} xs={12} container direcion='row' className='payment-process-contract'>
            {!props.contractCreated ? (
              <Grid lg={8} md={12} sm={12} xs={12}>
                {
                  props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? (
                    <>
                      <h4> </h4>
                      <div className='container-detail container-detail-payment'>
                        <div className='container-cardCredit'>
                          <Field
                            style={{ maxWidth: '15px', marginLeft: '10px' }}
                            id={'a3Direct'}
                            name='checkA3Direct'
                            label={props.paymentType[2].name}
                            component={Checkbox}
                            value={props.a3Direct}
                            checked={props.a3Direct}
                            onChange={props.onAcceptA3Direct}
                          />
                        </div>
                      </div>
                    </>
                  ) :
                    (<>
                      <h4 className='payment-process-payment-type'>{t('planProcessView.paymentType')}</h4>
                      <div className='container-detail container-detail-payment'>
                        <div className='container-cardCredit'>
                          <Field
                            style={{ maxWidth: '15px', marginLeft: '10px' }}
                            id={'card'}
                            name='card'
                            label={props.paymentType[0].name}
                            component={Checkbox}
                            value={props.card}
                            checked={props.card}
                            onChange={props.onAcceptCard}
                            placeHolder
                          />
                          <span className='payment-process-validation'>{t('planProcessView.validation3D')}</span>
                        </div>
                        {props.card && !props.transfer ?
                          <div className='payment-process-container-form-buyer'>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <div className='tooltip-size'>
                                {/* <Tooltip
                                  position="right"
                                  anchorElement="target"
                                  content={(props) => {
                                    return <TooltipContentTemplate title={open ? t('planProcessView.toolTipFirst') : props.title} content={open ? t('planProcessView.tooltipFirstDetail') : ''} />
                                  }}
                                > */}
                                <Label className="display-span-pay">
                                  {t('planProcessView.cardName')}
                                  {/* <i
                                      className="k-icon k-i-information"
                                      style={iconTooltipStyles}
                                      title={t('signatureRequestView2.tooltipClic')}
                                      onClick={() => handleOnChangeTooltip()}
                                      onMouseOut={() => hiddeTooltip()}
                                    /> */}
                                </Label>
                                {/* </Tooltip> */}
                              </div>
                              <div className='input-mobile'>
                                <Field
                                  className="input-data-payment"
                                  style={{ fontFamily: 'Helvetica', fontWeight: '500' }}
                                  name={'cardName'}
                                  onFocus={() => { setCardName(false) }}
                                  onBlur={() => { setCardName(true) }}
                                  component={props.validateInput}
                                  validator={cardName && props.validator.cardNameValidator}
                                  required
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <div className='tooltip-size'>
                                {/* <Tooltip
                                  position="right"
                                  anchorElement="target"
                                  content={(props) => {
                                    return <TooltipContentTemplate title={open ? t('planProcessView.titleCardNumber') : props.title} content={open ? t('planProcessView.titleCardNumberDes') : ''} />
                                  }}
                                > */}
                                <Label className="display-span-pay">
                                  {t('planProcessView.cardNumber')}
                                  {/* <i
                                      className="k-icon k-i-information"
                                      style={iconTooltipStyles}
                                      title={t('signatureRequestView2.tooltipClic')}
                                      onClick={() => handleOnChangeTooltip()}
                                      onMouseOut={() => hiddeTooltip()}
                                    /> */}
                                </Label>
                                {/* </Tooltip> */}
                              </div>
                              <div className='input-mobile '>
                                <div className='input-data-payment'>
                                  <MaskedTextBox
                                    mask="0000-0000-0000-0000"
                                    name='creditCard'
                                    vulue={props.creditCard}
                                    onChange={props.onChangeValue}
                                    validityStyles={false}
                                    required={true}
                                    minLength={15}
                                    validationMessage='Ingresa un número de tarjeta'
                                  />
                                </div>
                              </div>
                              {props.errorNameUnique && <span className='hint-message-error-name'>{t('planProcessView.expirationDateError')}</span>}

                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <div className='tooltip-size'>
                                {/* <Tooltip
                                  position="right"
                                  anchorElement="target"
                                  content={(props) => {
                                    return <TooltipContentTemplate title={open ? t('planProcessView.titleExpirationDate') : props.title} content={open ? t('planProcessView.titleExpirationDateDes') : ''} />
                                  }}
                                > */}
                                <Label className="display-span-pay">
                                  {t('planProcessView.expirationDate')}
                                  {/* <i
                                    className="k-icon k-i-information"
                                    style={iconTooltipStyles}
                                    title={t('signatureRequestView2.tooltipClic')}
                                    onClick={() => handleOnChangeTooltip()}
                                    onMouseOut={() => hiddeTooltip()}
                                  /> */}
                                </Label>
                                {/* </Tooltip> */}
                              </div>
                              <div className='input-mobile '>
                                <MaskedTextBox
                                  className='input-data-payment'
                                  mask="00/00"
                                  name='expirationDate'
                                  value={props.expirationDate}
                                  onChange={props.onChangeValue}
                                  validityStyles={false}
                                  required={true}
                                  validationMessage="Ingresa la fecha de expiración"
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <div className='tooltip-size'>
                                {/* <Tooltip
                                  position="right"
                                  anchorElement="target"
                                  content={(props) => {
                                    return <TooltipContentTemplate title={open ? t('planProcessView.titleSecurityCode') : props.title} content={open ? t('planProcessView.titleSecurityCodeDes') : ''} />
                                  }}
                                > */}
                                <Label className="display-span-pay">
                                  {t('planProcessView.securityCode')}
                                  {/* <i
                                      className="k-icon k-i-information"
                                      style={iconTooltipStyles}
                                      title={t('signatureRequestView2.tooltipClic')}
                                      onClick={() => handleOnChangeTooltip()}
                                      onMouseOut={() => hiddeTooltip()}
                                    /> */}
                                </Label>
                                {/* </Tooltip> */}
                              </div>
                              <div className='input-mobile '>
                                <Field
                                  name={'securityCode'}
                                  type="password"
                                  onFocus={() => { setSecurityCode(false) }}
                                  onBlur={() => { setSecurityCode(true) }}
                                  component={props.validateInput}
                                  validator={securityCode && props.validator.securityCodeValidator}
                                  className="input-data-payment"
                                  maxLength={3}
                                  required
                                />
                              </div>
                            </Grid>
                            <div className='payment-process-container-question'>
                              <a href="https://www.openpay.mx/docs/three-d-secure.html" target="_blank" className='text-information'><span>{t('planProcessView.whatis3D')}</span></a>
                            </div>
                            <div className='payment-process-container-pay-transfer'>
                              <span>{t('planProcessView.loadPayment')}</span><br></br>
                              <span className='text-pay-online'>{t('planProcessView.onlinePayment')}</span>
                            </div>
                          </div>
                          : ""}
                      </div>
                      <div className='container-detail container-detail-payment'>
                        <div className='container-cardCredit'>
                          <Field
                            style={{ maxWidth: '15px', marginLeft: '10px' }}
                            id={'transfer'}
                            name='checkTransfer'
                            label={props.paymentType[1].name}
                            component={Checkbox}
                            value={props.transfer}
                            checked={props.transfer}
                            onChange={props.onAcceptTransfer}
                          />
                        </div>
                        {props.transfer && !props.card ?
                          <div className='payment-process-container-form-buyer'>
                            <span className='text-transfer'>Has elegido realizar el pago a través de SPEI (Transferencia bancaria) te solicitamos usar correctamente la información que te enviaremos a tu correo electrónico, tanto cuenta de depósito como referencias.  govo.digital no se hace responsable si se hace el depósito a una cuenta diferente a la indicada. Una vez que hayas realizado la transferencia correctamente, el proceso tardará alrededor de 20 minutos en reflejarse en el sistema.</span>
                            <div>
                              <Field
                                style={{ maxWidth: '15px', marginLeft: '10px' }}
                                id={'messageTransfer'}
                                name='checkTransferMessage'
                                label={t('planProcessView.readMessage')}
                                component={Checkbox}
                                value={props.messageTransfer}
                                checked={props.messageTransfer}
                                onChange={props.onAcceptMessageTransfer}
                              />
                            </div>
                          </div>
                          :
                          ""
                        }
                      </div>
                    </>)
                }
                {/* <h4>Datos del comprador</h4>
                          <div className='container-detail-buyer'>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <span className='display-span-pay'>Nombre</span>
                              <div className='form-buyer'>
                                <Field
                                  className='input-data-payment'
                                  onFocus={() => { setFirstName(false) }}
                                  onBlur={() => { setFirstName(true) }}
                                  name={"firstName"}
                                  component={props.validateInput}
                                  validator={firstName && props.validator.nameValidator}
                                  minLength={2} required
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <span className='display-span-pay'>Apellidos</span>
                              <div className='form-buyer'>
                                <Field
                                  className='input-data-payment'
                                  onFocus={() => { setLastName(false) }}
                                  onBlur={() => { setLastName(true) }}
                                  name={"lastName"}
                                  component={props.validateInput}
                                  validator={lastName && props.validator.firstLastNameValidator }
                                  minLength={2} required
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <span className='display-span-pay'>Telefono</span>
                              <div className='form-buyer'>
                                <Field
                                  className='input-data-payment'
                                  onFocus={() => { setCellNumber(false) }}
                                  onBlur={() => { setCellNumber(true) }}
                                  name={"cellNumber"}
                                  component={props.validateInput}
                                  validator={cellNumber && props.validator.cellphoneValidato}
                                  minLength={2} required
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <span className='display-span-pay'>Correo electrónico</span>
                              <div className='form-buyer'>
                                <Field
                                  className='input-data-payment'
                                  onFocus={() => { setEmail(false) }}
                                  onBlur={() => { setEmail(true) }}
                                  name={"email"}
                                  component={props.validateInput}
                                  validator={email && props.validator.emailValidator}
                                  minLength={2} required
                                />
                              </div>
                            </Grid>
                            <Grid className='grid-complete-payment' item xs={12} lg={6} md={12} sm={12} es={12}>
                              <span className='display-span-pay'>Confirmación de correo</span>
                              <div className='form-buyer'>
                                <Field
                                  className='input-data-payment'
                                  onFocus={() => { setConfirmEmail(false) }}
                                  onBlur={() => { setConfirmEmail(true) }}
                                  name={"confirmEmail"}
                                  component={props.validateInput}
                                  validator={confirmEmail && props.validator.emailValidator}
                                  minLength={2} required
                                />
                              </div>
                            </Grid>
                          </div> */}
              </Grid>
            ) : (

              <Grid lg={6} md={12} sm={12} xs={12}>
                {
                  props.card && <div className='container-sucessful-ad'>
                    <span className='payment-process-attention-sucessful'>{t('planProcessView.successfulProcess')}</span>
                    <p className='payment-process-text-sucessful '>{t('planProcessView.terminationCard')}
                      <span className='payment-process-attention'> ***** {props.creditCard.substring(12, 16)}</span>{t('planProcessView.next')}
                    </p>
                  </div>
                }
                {
                  props.transfer &&
                  <Grid>
                    <div className='container-sucessful-ad'>
                      <span className='payment-process-attention-sucessful'>{t('planProcessView.successfulProcess')}</span>
                      <p className='payment-process-text-sucessful '>
                        Se creo la referencia bancaria para que puedas realizar el depósito correspondiente del
                        paquete de firmas seleccionado, te hemos enviado un correo electrónico con toda la información
                        necesaria para realizarlo. da clic en 'Continuar' para checar el resumen.
                      </p>
                    </div>
                    <div className='container-transfer'>
                      <div className='card-transferType'>
                        <span className='title-type-transfer'>{t('paymentProcess.bank')}</span>
                        <p>{t('paymentProcess.bankDescription')}</p>
                        <div className='align-transfer-type'>
                          <span className='title-type-transfer'>{t('paymentProcess.agreementNumber')}</span>
                          <div>
                            <span className='number-contract'>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.agreement : props.createdContractRenewal.bankcharge.payment_method.agreement}</span>
                          </div>
                        </div>
                        <p>{t('paymentProcess.operationRecords')}</p>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.reference')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.name : props.createdContractRenewal.bankcharge.payment_method.name}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.amount')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>MX{props.creactedContract ? props.priceContract : props.priceContractRenewal}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.concept')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{t('paymentProcess.buySignaturePackage')}</span>
                          </Grid>
                        </Grid>
                      </div>
                      <div className='card-transferType'>
                        <span className='title-type-transfer'>{t('paymentProcess.otherBank')}</span>
                        <p>{t('paymentProcess.transferData')}</p>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.beneficiary')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.merchant.name : props.createdContractRenewal.bankcharge.payment_method.name}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.destinationBank')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.bank : props.createdContractRenewal.bankcharge.payment_method.bank}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t("paymentProcess.payConcept")}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.name : props.createdContractRenewal.bankcharge.payment_method.name}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.cable')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.clabe : props.createdContractRenewal.bankcharge.payment_method.clabe}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.reference')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>{props.creactedContract ? props.creactedContract.bankcharge.payment_method.agreement : props.createdContractRenewal.bankcharge.payment_method.agreement}</span>
                          </Grid>
                        </Grid>
                        <Grid className='container-transfer-packet' xs={12} lg={12} md={12} sm={12}>
                          <Grid xs={4} lg={4} md={4} sm={4} className='spacing-car'>
                            <span className='text-transfer-type'>{t('paymentProcess.amount')}</span>
                          </Grid>
                          <Grid xs={6} lg={6} md={6} sm={6} className='detail-transfer'>
                            <span>MX{props.creactedContract ? props.priceContract : props.priceContractRenewal}</span>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </Grid>
                }
                {
                  props.a3Direct && <div className='container-sucessful-ad'>
                    <span className='payment-process-attention-sucessful'>{t('planProcessView.successfulProcess')}</span>
                    <p className='payment-process-text-sucessful '>
                      {
                        t('planProcessView.successfulProcessA3Direct1') + " " + `${props.folio.toUpperCase().substring(props.folio.length - 5, props.folio.length)}` + t('planProcessView.successfulProcessA3Direct2')
                      }
                    </p>
                  </div>
                }
              </Grid>
            )
            }
            <Grid lg={4} md={12} sm={12} xs={12}>
              <Grid xs={12} lg={12} md={12} sm={12}>
                <h4 className='payment-process-payment-type' style={{ paddingLeft: '10px' }}>{t('planProcessView.car')}</h4>
                {/* <Grid className='container-detail-car' xs={12} lg={12} md={12} sm={12}> */}
                {/* <Grid xs={8} lg={8} md={8} sm={8} className='package-general-information'>
                    <div>
                      <span>{t('planProcessView.packet')} {props.selectedPlanPricingId === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? ' 2000 plus' : " " + props.planStandard + "  " + props.selectedPlanLevel.monthlyTransaction} </span>&nbsp;
                    </div>
                    {props.selectedPlanPricingId === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? ""
                      :
                      <span className='package-general-information-subtitle'>{props.selectedPlanLevel.monthlyTransaction} {t('planProcessView.signaturesAnnual')}</span>
                    }
                  </Grid>
                  {props.selectedPlanPricingId === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? "" :
                    <Grid xs={4} lg={4} md={4} sm={4} className='price'>
                      <span> {props.planProSelectPrice}</span>
                    </Grid>
                  }
                </Grid> */}
                {props.assignedPlans[0] ?
                  <Grid className='container-detail-car' xs={12} lg={12} md={12} sm={12}>
                    {props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ?
                      <Grid xs={12} lg={12} md={12} sm={12} className='package-general-information'>
                        <div>
                          <span> {props.assignedPlans[0].name} </span>&nbsp;
                        </div>
                        {props.assignedPlans[0].key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY ? null : <span className='package-general-information-subtitle'>{props.assignedPlans[0].monthlyTransaction} {t('planProcessView.signaturesAnnual')}</span>}

                      </Grid>
                      :
                      <>
                        <Grid xs={7} lg={7} md={7} sm={7} className='package-general-information'>
                          <div>
                            <span> {props.assignedPlans[0].name} </span>&nbsp;
                          </div>
                          {props.assignedPlans[0].key === process.env.REACT_APP_PLAN_STANDAR_PLUS_KEY ? null : <span className='package-general-information-subtitle'>{props.assignedPlans[0].monthlyTransaction} {t('planProcessView.signaturesAnnual')}</span>}

                        </Grid>
                        <Grid xs={5} lg={5} md={5} sm={5} className='payment-process-price'>
                          <span> {props.assignedPlans[0].pricing} </span>
                        </Grid>
                      </>
                    }
                  </Grid>
                  : null
                }
                {props.assignedPackage[0] ?
                  <Grid className='container-detail-car' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={7} lg={7} md={7} sm={7} className='package-general-information'>
                      <div>
                        <span> {props.assignedPackage[0].name} </span>&nbsp;
                      </div>
                      <span className='package-general-information-subtitle'>{props.assignedPackage[0].monthlyTransaction} {t('planProcessView.signaturesAnnual')}</span>

                    </Grid>
                    <Grid xs={5} lg={5} md={5} sm={5} className='payment-process-price'>
                      <span> {props.assignedPackage[0].pricing} </span>
                    </Grid>
                  </Grid>
                  : null
                }
                {props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? "" :
                  <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={8} lg={8} md={8} sm={8} className='spacing-car'>
                      <h4 className='package'>{t('planProcessView.signaturespacket')} </h4>
                    </Grid>
                    <Grid xs={4} lg={4} md={4} sm={4} className='payment-process-price space-iva'>
                      <span> {props.subtotal}</span>
                    </Grid>
                  </Grid>
                }
                {props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? "" :
                  <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                    <Grid xs={8} lg={8} md={8} sm={8} className='spacing-car'>
                      <h4 className='package'>{t('planProcessView.signatureIVA')} </h4>
                    </Grid>
                    <Grid xs={4} lg={4} md={4} sm={4} className='payment-process-price space-iva'>
                      <span>{props.iva}</span>
                    </Grid>
                  </Grid>
                }
                {props.selectedPlanPricingId[0] === Number(process.env.REACT_APP_PLAN_STANDAR_PLUS) ? "" :
                  <div className='container-detail'>
                    <Grid className='container-package' xs={12} lg={12} md={12} sm={12}>
                      <Grid xs={8} lg={8} md={8} sm={8} className='spacing-car'>
                        <h4 className='package'>{t('planProcessView.total')} </h4>
                      </Grid>
                      <Grid xs={4} lg={4} md={4} sm={4} className='payment-process-price'>
                        <span className='payment-process-total'>{props.total}</span>
                      </Grid>
                    </Grid>
                  </div>
                }
              </Grid>
              {
                props.contractCreatedError && props.card && <div className='container-error-ad'>
                  <span className='attention-error'>{t('planProcessView.processNotSuccessful')}</span>
                  <p className='text-error'>{t('planProcessView.terminationCardCredit')}<span className='payment-process-attention'> ***** {props.creditCard && props.creditCard.substring(15, 21)}</span>{t('planProcessView.not successful')}</p>
                </div>
              }
              {
                props.contractCreatedError && props.transfer && <div className='container-error-ad'>
                  <span className='attention-error'>{t('planProcessView.processNotSuccessful')}</span>
                  <p className='text-error'>{t('planProcessView.target')}</p>
                </div>
              }
              {
                props.contractCreatedError && props.a3Direct && <div className='container-error-ad'>
                  <span className='attention-error'>{t('planProcessView.processNotSuccessful')}</span>
                  <p className='text-error'>{t('planProcessView.a3')}</p>
                </div>
              }
              {(props.transfer && !props.contractCreatedError) || (props.card && !props.contractCreatedError) ?
                <div className='container-openpay'>
                  <span className='openpay-text'>Powered by</span>
                  <img className='openpay' src={OpenPay} />
                </div>
                : ""}
              {
                !props.contractCreated && <Grid xs={12} lg={12} md={12} sm={12} >
                  <div className='container-detail-ad'>
                    <span>{t('planProcessView.attention')}</span>
                    <p className='payment-process-text-attention'>{t('planProcessView.buySingaturesPacket')} <span className='payment-process-attention'>{(props.assignedPackage[0]) ? (props.assignedPlans[0]) ? (props.assignedPlans[0] && props.assignedPackage[0]) ? props.assignedPlans[0].name + ' y ' + props.assignedPackage[0].name : null : props.assignedPackage[0].name : props.assignedPlans[0].name}</span>. {t("planPRocessView.noDevolutions")}</p>
                  </div>
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      </div >
    </Container >
  )
}

export { PaymentProcessView as default }